import { render, staticRenderFns } from "./nodata_table.vue?vue&type=template&id=0818315e"
import script from "./nodata_table.vue?vue&type=script&lang=js"
export * from "./nodata_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports